export default __webpack_public_path__ + "static/media/body_screening.1e6ee364.png";